import { render, staticRenderFns } from "./NuevaRaya.vue?vue&type=template&id=ebd0ce32"
import script from "./NuevaRaya.vue?vue&type=script&lang=js"
export * from "./NuevaRaya.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports